import styled from "styled-components/macro";
import { typography } from "@joor/design-system";

const StyledWrapper = styled.div``;
const StyledTitle = styled.h1`
  ${typography.alpha.primaryActive.headline1}
  margin-top: 30px;
  text-transform: none;
  letter-spacing: 0;
  text-align: center;
`;
const StyledInfo = styled.p`
  ${typography.alpha.primaryActive.subtitle3}
  color: ${(props) => props.theme.colors.secondary};
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  margin-bottom: 30px;
  text-align: center;
`;
export const NotFound = () => (
  <StyledWrapper>
    <StyledTitle>We're Sorry—</StyledTitle>
    <StyledInfo>We couldn't find the page you were looking for.</StyledInfo>
  </StyledWrapper>
);
